import { AppBar, Box, Grid, Toolbar } from "@mui/material";
import useGlobal from "../../../util/Global";


const AdayContainer = ({ children }) => {

    const { t } = useGlobal();

    return (
        <>
            <AppBar className="adaymenu" position="static" sx={{ color: "white" }}>
                <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
                    {/* Logo Section */}
                    <Grid container spacing={4} maxWidth="100vw" sx={{ alignItems: "center", ml: '1vw' }}>
                        <Grid item xs={12}>
                            <img
                                src="/securitas-logo-forwhitebackground.svg" // Replace with actual image path
                                style={{ width: "5rem", borderRadius: "8px" }}
                            />
                            <span style={{ marginleft: "5px", color: "#888888", fontsize: "1rem" }}> {t("title.EbasvuruPortal")} </span>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <Box
                sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                {children}
            </Box >
        </>
    );
}

export default AdayContainer;